import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { formatPageTitle } from '../lib/pageFocus';

/** Name the page in the tab title (WCAG 2.4.2). Leave `page` out on the home page. */
export function usePageTitle(page?: string) {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = formatPageTitle(page, t('brand.name'), t('pageTitle.home'));
  }, [page, t]);
}
